module.exports = __webpack_public_path__ + "static/img/minHeader4.e562d10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/minHeader4.png
// module id = N8Oq
// module chunks = 0